export default __webpack_public_path__ + "static/media/art-brw-banner-1.9e9afdb5.jpg";